import { GameProps } from '@/components/Gameinterfaces';

export type GamePriceType = number | null;

interface GameStepCouponsProps extends GameProps {
  [key: string]: any;
}

export function calculateGamePrice(
  filledCoupons: number,
  couponProps: GameStepCouponsProps
): number | null {
  if (couponProps.selectedWeeklySubscription) {
    return null;
  }

  const priceCoupon = couponProps.couponGroup
    ? couponProps.couponGroup.couponPrice
    : 0;
  const daysPerWeek = couponProps.selectedDrawDays.length;
  const drawNumber = couponProps.selectedDrawNumber
    ? couponProps.selectedDrawNumber
    : 1;
  const drawRate = couponProps.selectedDrawRate
    ? couponProps.selectedDrawRate
    : 1;
  const basePrice = couponProps.basePrice ? couponProps.basePrice : 0;
  const additionalGames =
    couponProps.additionalGames &&
    couponProps.additionalGames
      .filter(
        (game) =>
          couponProps.selectedAdditionalGames &&
          game.additionalGameId &&
          couponProps.selectedAdditionalGames.indexOf(game.additionalGameId) >=
            0
      )
      .map((game) => game.data);
  const _daysPerWeek = Math.max(daysPerWeek, 1);
  const priceAdditionalGames: number = additionalGames
    ? additionalGames.reduce((price, data): number => {
        if (!data) {
          return price;
        }
        price += data.dependsOnDrawDays
          ? data.price * _daysPerWeek
          : data.price;
        return price;
      }, 0) * couponProps.selectedWeeksNumber
    : 0;

  const multiple = _daysPerWeek * couponProps.selectedWeeksNumber;
  return (
    (priceCoupon * filledCoupons * multiple * drawRate +
      priceAdditionalGames +
      basePrice * multiple) *
    drawNumber
  );
}
